var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthWxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2246_5365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2246_5365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 0C8.05907 0 0 8.05856 0 17.9998C0 27.9406 8.05907 36 18.0001 36C27.9411 36 36 27.9406 36 17.9998C36 8.05856 27.9409 0 18.0001 0Z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2246_5365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6495 0L17.4082 0.820144V24.6188L17.6495 24.8597L28.6966 18.3298L17.6495 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6447 0L6.59766 18.3298L17.6447 24.8598V13.3086V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6496 26.9524L17.5137 27.1182V35.5958L17.6496 35.993L28.7033 20.4258L17.6496 26.9524Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6447 35.993V26.9524L6.59766 20.4258L17.6447 35.993Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 24.8606L28.6953 18.3307L17.6484 13.3096V24.8606Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59766 18.3308L17.6446 24.8606V13.3096L6.59766 18.3308Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -4,
    y: 19.5,
    width: 43.9091,
    height: 10.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7172 28.5H15.3652V27.8182H15.0132V27.1364H14.6612V26.4545H14.3092V25.7727H13.9571V25.0909H13.6051V24.4091H13.2531V25.0909H12.9011V25.7727H12.5491V26.4545H12.1971V27.1364H11.8451V27.8182H11.4931V28.5H11.1411V21H12.1971V24.75H12.5491V24.0682H12.9011V23.3864H13.2531V22.7045H13.6051V23.3864H13.9571V24.0682H14.3092V24.75H14.6612V21H15.7172V28.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 28.5H19.9436V27.4773H19.5916V26.4545H19.2396V25.7727H18.8876V25.4318H18.5356V25.7727H18.1836V26.4545H17.8316V27.4773H17.4795V28.5H16.4235V27.4773H16.7755V26.4545H17.1275V25.7727H17.4795V25.0909H17.8316V24.4091H17.4795V23.7273H17.1275V23.0455H16.7755V22.0227H16.4235V21H17.4795V22.0227H17.8316V23.0455H18.1836V23.7273H18.5356V24.0682H18.8876V23.7273H19.2396V23.0455H19.5916V22.0227H19.9436V21H20.9997V22.0227H20.6476V23.0455H20.2956V23.7273H19.9436V24.4091H19.5916V25.0909H19.9436V25.7727H20.2956V26.4545H20.6476V27.4773H20.9997V28.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2821 27.8182H25.9301V28.1591H25.5781V28.5H23.114V28.1591H22.762V27.8182H22.41V27.4773H22.058V27.1364H21.706V22.3636H22.058V22.0227H22.41V21.6818H22.762V21.3409H23.114V21H25.5781V21.3409H25.9301V21.6818H26.2821V22.3636H25.2261V22.0227H23.466V22.3636H23.114V22.7045H22.762V26.7955H23.114V27.1364H23.466V27.4773H25.2261V25.4318H24.8741V25.7727H23.818V24.4091H26.2821V27.8182Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2246_5365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthWxg);
export default __webpack_public_path__ + "static/media/ETH-WXG.d9a8a75328def3bd0f876300243b50fa.svg";
export { ForwardRef as ReactComponent };